import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dict } from "./translations";
import { track, EVENTS } from "./events";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("briouse.locale") : null;
    return saved === "en" ? "en" : "fr";
  });

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const setLocale = useCallback((next) => {
    setLocaleState(next);
    localStorage.setItem("briouse.locale", next);
    track(EVENTS.LANGUAGE_SWITCH, { to: next });
  }, []);

  const t = useCallback(
    (key) => {
      const parts = key.split(".");
      let node = dict[locale];
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else return key;
      }
      return typeof node === "string" ? node : key;
    },
    [locale]
  );

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
